import { CLEAR_ALL_FILTERS } from "./actionTypes";

export default (objectType) => ({
  type: CLEAR_ALL_FILTERS,
  payload: {
    objectType
  }
});